import {
  APP_INITIALIZER,
  ApplicationConfig,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient } from '@angular/common/http';
import { RECAPTCHA_LOADER_OPTIONS } from 'ng-recaptcha-2';

import { routes } from './app.routes';
import { GrafanaFaroService } from './shared/services/grafana-faro.service';
import { provideTrackerErrorInitializer } from './shared/providers/tracker-error.provider';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideHttpClient(),
    {
      provide: APP_INITIALIZER,
      useFactory: provideTrackerErrorInitializer,
      multi: true,
      deps: [GrafanaFaroService],
    },
    {
      provide: RECAPTCHA_LOADER_OPTIONS,
      useValue: {
        onBeforeLoad(url: URL) {
          url.searchParams.set('hl', 'pt-BR');

          return { url };
        },
      },
    },
  ],
};
